$(function() {
	initRefAccordion();
});

function initRefAccordion() {
	$('.resources-and-references .trigger').on('click', function(e) {
		$(this).toggleClass('open');
		var el = $(this).next('.resources-and-references .text');
		var vis = el.is(":visible");
		$('.resources-and-references .text').slideUp();
		el[ vis ? "slideUp" : "slideDown"]();
	});
}